var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-12 pt-16",style:({ minHeight: _vm.panelMinHeight })},[(_vm.datas.length)?_vm._l((_vm.datas),function(data){return _c('GuideCard',{key:data.guideId,ref:"cards",refInFor:true,staticClass:"[&:not(:first-child)]:mt-16",attrs:{"data":data}})}):_c('DataEmpty')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }